export enum ProgressNodeStatusEnum {
  none,
  wrong,
  correct, // correct in multiple tries
  perfect, // correct in one try
  complete, // can't assess at current moment so participation status
}
